<div class="ub ub-ver fw flow-print" :class="{'in-iframe':isIframe}">
  <div class="ub ub-ac ub-pb fw h48px bgfff pdl16 pdr16 dayin">
    <div>
      <slot name="tab">

      </slot>

      <a-checkbox-group
        class="ub ub-f1"
        v-model:value="selectedCheckbox"
        name="checkboxgroup"
        :options="checkboxes"
      />
    </div>

    <a-space>
      <a-button type="primary" v-print="printConfig">打印</a-button>
      <a-button @click="cancel">关闭</a-button>
    </a-space>
  </div>
  <div class="ub ub-ver fw print-div" id="flow-print-table">
    <template v-for="(item,index) in loopSection" :key="index">
      <slot name="header" v-if="item.show&&item.value==='header'" :record="basicInfo">
        <div class="ub ub-ver ub-ac ub-pc fw bgfff header">
          <div class="ub ub-ac ub-ps fw nav pdl16 pdr16">
            <slot name="nav"></slot>
          </div>
          <div class="ub ub-ac ub-pc title">
            <slot name="title">{{basicInfo?.name??basicInfo?.projectName}}</slot>
          </div>
          <div class="ub ub-ac ub-pc sub-title">
            <slot name="subTitle">
              <a-descriptions :column="2" style="max-width: 1100px">
                <a-descriptions-item :label="bizNoLabelName"
                  >{{basicInfo?.bizNo}}</a-descriptions-item
                >
                <a-descriptions-item
                  :label="validStatusLabelName"
                  :labelStyle="{
                    width:labelWidth+'px',
                    textAlign:'right',
                    display:'block'
                  }"
                  v-if="!basicInfo?.projectStatusName&&validStatusLabelName?.length>0"
                  >{{basicInfo?.statusName??basicInfo?.validStatusName}}</a-descriptions-item
                >
                <a-descriptions-item
                  :label="'项目状态'"
                  :labelStyle="{
                  width:labelWidth+'px',
                  textAlign:'right',
                  display:'block'
                }"
                  v-if="basicInfo?.projectStatusName"
                  >{{basicInfo?.projectStatusName??basicInfo?.statusName}}</a-descriptions-item
                >
                <a-descriptions-item label="审批状态"
                  >{{basicInfo?.flowStatusName}}</a-descriptions-item
                >
                <a-descriptions-item
                  label="合同状态"
                  :labelStyle="{
                  width:labelWidth+'px',
                  textAlign:'right',
                  display:'block'
                }"
                  v-if="contractStatusLabelNameKey?.length>0"
                  >{{contractStatusLabelNameKey}}</a-descriptions-item
                >
                <a-descriptions-item label="打印日期">{{nowStr}}</a-descriptions-item>
              </a-descriptions>
            </slot>
          </div>
        </div>
      </slot>
      <slot name="tabHeader" :record="basicInfo" v-if="item.show&&item.value==='tab'"> </slot>
      <print-item
        :label="item.label"
        :class="[index==1?'first-print-item':'',index==loopSection.length-1?'last-print-item':'']"
        v-if="item.show && item.value !=='header'&& item.value !=='tab' && item.value !== 'qrcode'"
      >
        <template #header>{{item.label}}</template>
        <template #body>
          <slot :name="item.value" :record="basicInfo">
            <attachment
              v-if="item.value === 'attach'"
              v-model:value="attachList"
              :biz-id="id"
              :biz-type="attachBizType"
            ></attachment>
            <approval-flow-log-table
              v-if="item.value==='flow'"
              :biz-id="id"
              :biz-type="flowBizType"
            ></approval-flow-log-table>
          </slot>
        </template>
      </print-item>
    </template>
    <slot name="qrcode" v-if="showQrcode">
      <div class="ub ub-ac ub-pc ub-ver qrcode-div">
        <qrcode-image :content="qrcodeUrl" v-if="qrcodeUrl"></qrcode-image>
        <img
          style="width: 130px; height: 130px"
          src="data:image/png;base64,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"
          v-else
        />
        <div class="ub ub-ac ub-pc qrcode-text">打开微信扫描二维码，查看详情</div>
      </div>
    </slot>
  </div>
</div>
